export default __webpack_public_path__ + "static/media/Drop.3184eded.svg";